export const UriImage = [
  { uri: '../../../assets/img/HEAD.png'},
  { uri: '../../../assets/img/HEAD-812.png'},
  { uri: '../../../assets/img/HEAD-640.png'},
]
